import { axios } from "../../config/axios";

export const bonusRulesAPI = {

  /**
   * Get data from the given endpoint
   * @param {string} endpoint - Endpoint
   * @returns {*}
   */
  getDataFromUrl(endpoint) {
    return axios.get(endpoint)
    .then( res => res.data );
  },

  /**
   * Get event types for bonus engine
   * @returns {array} Array of event types
   */
  getEventTypes() {
    return axios.get(`/api/v3/bonus_rules/options`)
      .then( res => res.data.event_types );
  },

  /**
   * Get event options for bonus engine
   * @param {string} data_url
   * @param {object} params
   * @returns {array} Array of options available for an event
   */
  getEventOptions(data_url, params) {
    return axios.get(data_url, { params })
    .then( res => res.data );
  },

};
